import { accessMappingData, AccessMappingDataType } from "./helper";

const useShowPropertyType = (
  propertyType: number | null,
  whatToDo: AccessMappingDataType
) => {
  if (propertyType === null || propertyType === undefined) return false;

  const allowedStatuses: number[] = accessMappingData[whatToDo];
  return allowedStatuses.indexOf(propertyType) !== -1;
};

export default useShowPropertyType;
